var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { white: _vm.white }, attrs: { id: "commonBackHeader" } },
    [
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "left" }, [
          _vm.showReturn
            ? _c("img", {
                attrs: {
                  src: _vm.whiteText
                    ? require("@/assets/whiteBack.png")
                    : require("@/assets/returnBtn.png"),
                  alt: "",
                },
                on: { click: _vm.back },
              })
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            staticClass: "title",
            class: { whiteText: _vm.whiteText, noShowReturn: !_vm.showReturn },
          },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
        _vm.showMsg
          ? _c("img", {
              attrs: {
                src: _vm.whiteText
                  ? require("@/assets/massageIcon.png")
                  : require("@/assets/massageIcon.png"),
                alt: "",
              },
              on: {
                click: function ($event) {
                  _vm.showDownloadGuide = true
                },
              },
            })
          : _vm._e(),
      ]),
      _vm.showDownloadGuide
        ? _c("common-download-guide", {
            model: {
              value: _vm.showDownloadGuide,
              callback: function ($$v) {
                _vm.showDownloadGuide = $$v
              },
              expression: "showDownloadGuide",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }